{
  "createProfile": {
    "title": "Complétez votre profil",
    "description": "Veuillez compléter votre profil pour commencer à utiliser la plateforme",
    "avatar": "Photo de profil",
    "firstName": "Prénom",
    "lastName": "Nom",
    "email": "Email",
    "phone": "Téléphone",
    "gender": "Sexe",
    "man": "Homme",
    "woman": "Femme",
    "other": "Autre",
    "practitionerType": "Type de praticien",
    "practitioner": "Praticien",
    "institution": "Institution",
    "institutionDetails": "Détails de l'institution",
    "institutionAvatar": "Logo de l'institution",
    "institutionName": "Nom de l'institution",
    "country": "Pays",
    "state": "État",
    "city": "Ville",
    "zipCode": "Code postal",
    "address": "Adresse",
    "companyRegistration": "Numéro d'enregistrement",
    "invoicingDetails": "Détails de facturation",
    "company": "Entreprise",
    "createProfile": "Créer le profil",
    "invalidFile": "Fichier invalide",
    "avatarPreview": "Aperçu de l'avatar",
    "institutionAvatarPreview": "Aperçu du logo de l'institution",
    "imageHint": "PNG ou JPEG, max 2 Mo",
    "healthDataConsent": {
      "title": "Consentement au traitement des données de santé",
      "description": "Conformément à l'article 9 du RGPD, le traitement de données de santé nécessite votre consentement explicite. Les données de santé collectées (évaluations cliniques, anamnèses, conclusions diagnostiques) sont traitées uniquement dans le cadre de votre activité professionnelle.",
      "label": "Je consens au traitement de mes données de santé et de celles de mes patients dans le cadre des évaluations cliniques"
    }
  },
  "invitation": {
    "welcome": {
      "title": "Invitation à rejoindre {{institutionName}}",
      "description": "Vous avez été invité à rejoindre {{institutionName}} sur MetaDevProfile",
      "institutionLabel": "Institution",
      "continue": "Continuer"
    },
    "setPassword": {
      "title": "Définir votre mot de passe",
      "description": "Choisissez un mot de passe sécurisé pour votre compte",
      "password": "Mot de passe",
      "confirmPassword": "Confirmer le mot de passe",
      "passwordMinLength": "Au moins 6 caractères",
      "passwordsMatch": "Les mots de passe doivent correspondre",
      "continue": "Continuer",
      "back": "Retour"
    },
    "completeProfile": {
      "title": "Complétez votre profil",
      "description": "Quelques informations supplémentaires pour finaliser votre compte",
      "firstName": "Prénom",
      "lastName": "Nom",
      "phone": "Téléphone",
      "gender": "Sexe",
      "genderOptions": {
        "MAN": "Homme",
        "WOMAN": "Femme",
        "OTHER": "Autre"
      },
      "complete": "Terminer",
      "back": "Retour"
    },
    "success": {
      "title": "Bienvenue dans {{institutionName}} !",
      "description": "Votre compte a été créé avec succès. Vous pouvez maintenant accéder à MetaDevProfile.",
      "goToDashboard": "Accéder au tableau de bord"
    },
    "errors": {
      "invitationNotFound": "Invitation introuvable",
      "invitationExpired": "Cette invitation a expiré",
      "invitationAlreadyAccepted": "Cette invitation a déjà été acceptée",
      "invalidPassword": "Mot de passe invalide",
      "passwordMismatch": "Les mots de passe ne correspondent pas",
      "profileError": "Erreur lors de la création du profil"
    }
  }
}
